import { Backdrop, BoxProps, LinearProgress, styled } from '@mui/material';
import React from 'react';
import Box from '@mui/material/Box';
import Logo from 'src/components/common/Logo';

const ImageContainer = styled(Box)<BoxProps>(() => ({
    '&.MuiBox-root': {
        position: 'relative',
    },
}));

const StyledImage = styled(Logo)(() => ({
    width: '150px',
}));

const HueOverlay = styled(Box)(() => ({
    '@keyframes moveOverlay': {
        '0%': {
            transform: 'translate(100%, 100%)',
        },
        '100%': {
            transform: 'translate(-100%, -100%)',
        },
    },
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgb(247,15,255)',
    mixBlendMode: 'hue',
    borderRadius: '100%',
    zIndex: 10,
    animation: 'moveOverlay 3s linear infinite',
}));

const ModuleFallBack: React.FC = () => {
    return (
        <Backdrop
            sx={{ zIndex: 3500, backgroundColor: 'secondary.100' }}
            open={true}
        >
            <Box sx={{ textAlign: 'center' }}>
                <ImageContainer sx={{ mb: 2 }}>
                    <StyledImage />
                    <Box
                        sx={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            top: 0,
                        }}
                    >
                        <Box
                            sx={{
                                position: 'relative',
                                width: '150px',
                                height: '150px',
                                borderRadius: '50px 25px 50px 50px',
                                overflow: 'hidden',
                            }}
                        >
                            <HueOverlay />
                        </Box>
                    </Box>
                </ImageContainer>

                <LinearProgress
                    sx={{
                        height: '8px',
                        width: '100%',
                        borderRadius: '8px',
                    }}
                    variant="indeterminate"
                    color="secondary"
                />
            </Box>
        </Backdrop>
    );
};

export default ModuleFallBack;
